import { render, staticRenderFns } from "./ImageUnderSection.vue?vue&type=template&id=041b768c&scoped=true&"
import script from "./ImageUnderSection.vue?vue&type=script&lang=js&"
export * from "./ImageUnderSection.vue?vue&type=script&lang=js&"
import style0 from "./ImageUnderSection.vue?vue&type=style&index=0&id=041b768c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b768c",
  null
  
)

export default component.exports